export function generatePaginationConfiguration(selected, pageCount) {
  const config = {
    left: [],
    right: [],
    breakView: null,
  };
  const items = [];
  const pageRangeDisplayed = 2;
  const marginPagesDisplayed = 3;
  const breakLabel = "...";

  if (pageCount <= pageRangeDisplayed) {
    for (let index = 0; index < pageCount; index++) {
      items.push(index);
      config.left.push(index);
    }
  } else {
    let leftSide = pageRangeDisplayed / 2;
    let rightSide = pageRangeDisplayed - leftSide;

    // If the selected page index is on the default right side of the pagination,
    // we consider that the new right side is made up of it (= only one break element).
    // If the selected page index is on the default left side of the pagination,
    // we consider that the new left side is made up of it (= only one break element).
    if (selected > pageCount - pageRangeDisplayed / 2) {
      rightSide = pageCount - selected;
      leftSide = pageRangeDisplayed - rightSide;
    } else if (selected < pageRangeDisplayed / 2) {
      leftSide = selected;
      rightSide = pageRangeDisplayed - leftSide;
    }

    let index;
    let page;
    let breakView;

    for (index = 0; index < pageCount; index++) {
      page = index + 1;

      // If the page index is lower than the margin defined,
      // the page has to be displayed on the left side of
      // the pagination.
      if (page <= marginPagesDisplayed) {
        items.push(index);
        config.left.push(index);
        continue;
      }

      // If the page index is greater than the page count
      // minus the margin defined, the page has to be
      // displayed on the right side of the pagination.
      if (page > pageCount - marginPagesDisplayed) {
        //   items.push(createPageView(index));
        items.push(index);
        config.right.push(index);
        continue;
      }

      // If the page index is near the selected page index
      // and inside the defined range (pageRangeDisplayed)
      // we have to display it (it will create the center
      // part of the pagination).
      if (index >= selected - leftSide && index <= selected + rightSide) {
        items.push(index);
        config.left.push(index);
        continue;
      }

      // If the page index doesn't meet any of the conditions above,
      // we check if the last item of the current "items" array
      // is a break element. If not, we add a break element, else,
      // we do nothing (because we don't want to display the page).
      if (breakLabel && items[items.length - 1] !== breakView) {
        items.push(breakView);
        breakView = "true";
        config.breakView = breakView;
        config.breakViewIndex = index;
      }
    }
  }
  return config;
}

export const groupBy = (data, groupByKey) => {
  if (!data.length || !Array.isArray(data)) return null;

  const groupedData = data.reduce((prev, curr) => {
    if (!prev[curr[groupByKey]]) prev[curr[groupByKey]] = [];
    prev[curr[groupByKey]].push(curr);
    return prev;
  }, {});
  return groupedData;
};

export function debounce(func) {
  var wait =
    arguments.length <= 1 || arguments[1] === undefined ? 100 : arguments[1];

  var timeout = void 0;
  return function() {
    var _this = this;

    for (
      var _len = arguments.length, args = Array(_len), _key = 0;
      _key < _len;
      _key++
    ) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function() {
      func.apply(_this, args);
    }, wait);
  };
}

export const formatToISOString = (timestamp) =>
  timestamp.toISOString().replace(/.\d+Z$/g, "Z");

export const getZonedTime = (date) => {
  if (!date) {
    return null;
  }
  const dateSplit = date.split('T');
  return new Date(`${dateSplit[0]}T18:30:00Z`);
};

export const isEmptyObject = (obj) => {
  for (let prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) return false;
  }

  return true;
};